/* Orvia · predictive search (Shopify Predictive Search API) */
(() => {
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.details = this.closest('details');
      let timer;
      this.input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.search(this.input.value.trim()), 250);
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.clear(); if (this.details) { this.details.open = false; this.details.querySelector('summary').focus(); } }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') this.move(e);
      });
      if (this.details) this.details.addEventListener('toggle', () => { if (this.details.open) this.input.focus(); });
    }
    async search(q) {
      if (q.length < 2) { this.clear(); return; }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      try {
        const url = `${this.dataset.url}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=4&resources[type]=product,collection,page,article,query`;
        const html = await (await fetch(url, { signal: this.controller.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-predictive-content]');
        this.results.innerHTML = content ? content.innerHTML : '';
        this.results.hidden = !content;
        this.input.setAttribute('aria-expanded', String(!!content));
      } catch (e) { /* aborted */ }
    }
    clear() { this.results.innerHTML = ''; this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
    move(e) {
      const links = [...this.results.querySelectorAll('a')];
      if (!links.length) return;
      e.preventDefault();
      const i = links.indexOf(document.activeElement);
      const next = e.key === 'ArrowDown' ? (i + 1) % links.length : (i <= 0 ? links.length - 1 : i - 1);
      links[next].focus();
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
})();
